import { broadcastLogout } from "@/auth/broadcast";
import { endSession } from "@/lib/analytics";
import { clearCapabilityToken } from "@/lib/concierge/capability-token";
import { clearStoredConversation } from "@/lib/order-assistant/storage";
import sdk from "@repo/api-sdk";
import { createRoute, redirect } from "@tanstack/react-router";
import { rootRoute } from "../$rootRoute";

export const logoutRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "logout",
  beforeLoad: async () => {
    try {
      await sdk.auth.logout();
    } catch (error) {
      // Log error but still proceed with logout
      console.error("Logout error:", error);
    }

    // The next person on this browser must not inherit this session's actor
    // attribution - a shared salon tablet is exactly the expected case.
    endSession();

    // Nor should they inherit an operator's ad hoc-add capability (KAN-193) -
    // same shared-tablet reasoning as `endSession()` above.
    clearCapabilityToken();

    // Nor the previous salon's order assistant conversation and session id,
    // which hold what they asked and what was answered (sessionStorage is
    // per tab, but a tab can sign in as another salon).
    clearStoredConversation();

    // Always broadcast and redirect, even if API call fails
    broadcastLogout();

    throw redirect({ to: "/login" });
  }
});
